import { LevelsEvents } from "~/utils/analytics";

export function sendNavigationEvent(gtag: Function, payload: { id: string, to: string }) {
  if (payload.to.includes("/facilities?level=")) {
    gtag("event", LevelsEvents.toFacilitiesPage, { level: payload.id });
  }
}